import { Link } from 'react-router-dom';
import { Logo } from '@/components/ui/Logo';
import { AuthHeader } from '@/components/AuthHeader';
import { AuthenticatedFooter } from './AuthenticatedFooter';
import { BillingStateBanner } from '@/components/BillingStateBanner';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

export const AuthenticatedLayout = ({ children }: AuthenticatedLayoutProps) => {
  return (
    <div className="min-h-screen bg-sand flex flex-col">
      {/* Main Header - Consistent across all authenticated pages */}
      <header className="bg-midnight-green/95 backdrop-blur-sm border-b border-deep-teal sticky top-0 z-50 shadow-lg shadow-black/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/app/dashboard">
                <Logo variant="horizontal" size="md" className="mr-2 brightness-0 invert" />
              </Link>
            </div>
            <AuthHeader />
          </div>
        </div>
      </header>

      {/* Billing State Banner */}
      <BillingStateBanner />

      {/* Page Content */}
      <div className="flex-1">
        {children}
      </div>

      {/* Footer */}
      <AuthenticatedFooter />
    </div>
  );
};
